






























































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { StartApplicationPickProgramsContent } from "@/models/content/start-application-pick-programs";

@Component({
  components: {
    FooterButton,
  },
})
export default class StartApplicationPickPrograms extends Mixins(CommonMixin) {
  content: StartApplicationPickProgramsContent = {} as StartApplicationPickProgramsContent;
  headStartChecked = false;
  greatStartChecked = false;
  appData = {} as AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getStartApplicationPickProgramsContent();
    this.textDirection = contentService.TextDirection();
    if (this.textDirection == "rtl") {
      this.checkTextAlign = "has-text-right";
    }

    this.appData = this.getAppData();

    if (this.appData != null) {
      this.headStartChecked = this.appData.applyHeadStart ?? false;
      this.greatStartChecked = this.appData.applyGreatStart ?? false;
      await this.putWorkflowStep( this.appData.workflowId, "StartApplicationPickPrograms") 
    }
  }

  public handleNextPageEvent(): void {
    this.appData.applyHeadStart = this.headStartChecked;
    this.appData.applyGreatStart = this.greatStartChecked;
    this.saveAppData(this.appData);
    this.$router.push({ path: "CareGiver1" });
  }

  disableNext(): boolean {
    return (
      this.appData == null || !(this.headStartChecked || this.greatStartChecked)
    );
  }
}
